export const updateMdrList = (dados) => {
    return {
        type: 'UPDATE_MDR_LIST',
        dados,
    };
};
export const clearMdrList = () => {
    return {
        type: 'CLEAR_MDR_LIST',
    };
};
export const selectMdrItem = (selectedItem) => {
    return {
        type: 'SELECT_MDR_ITEM',
        selectedItem,
    };
};
